import nextRow from "./nextRow";
import samePin from "./samePin";
import sameRow from "./sameRow";
import afterNextRow from "./afterNextRow";
import finalTouch from "../touch/finalTouch";

export default function nextDirection(pathName) {
  let touch, spin, time, column, movePath, finalAngle;
  const startingXY = this.board[this.row][this.column];
  switch (pathName) {
    case "samePin":
      [touch, spin, time, movePath, finalAngle] = samePin(
        this.movePath,
        this.handleFinalTouchAngle,
        this.spin
      );
      this.movePath = movePath;
      this.startingAngle = finalAngle;

      break;
    case "sameRow":
      [touch, spin, time, column, movePath, finalAngle] = sameRow(
        this.movePath,
        this.handleFinalTouchAngle,
        this.column
      );
      this.column = column;
      this.movePath = movePath;
      this.startingAngle = finalAngle;
      break;
    case "nextRow":
      [touch, spin, time, column, finalAngle] = nextRow(
        this.movePath,
        this.column,
        this.handleFinalTouchAngle,
        this.startingAngle,
        this.rows
      );
      this.row++;
      this.column = column;
      this.startingAngle = finalAngle;

      break;
    case "afterNextRow":
      [touch, spin, time, column, finalAngle] = afterNextRow(
        this.movePath,
        this.column,
        this.handleFinalTouchAngle,
        this.startingAngle,
        this.rows
      );
      this.row = this.row + 2;
      this.column = column;
      this.startingAngle = finalAngle;
      break;
    default:
      break;
  }
  this.spin = spin;
  const finalXY = this.board[this.row][this.column];
  finalTouch(
    startingXY,
    this.ctx,
    this.coef,
    this.anims,
    finalXY,
    this.final,
    touch,
    spin,
    this.handleCoordinates,
    this.handleTween,
    time,
    this.speed,
    this.rows
  );
}
